import React from 'react';

const Section3ProfessionalInfo = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">3. Educational & Professional Details</h4>
        <div className="mb-3">
            <label className="form-label">Education Qualification <span className="text-danger">*</span></label>
            <input type="text" name="education" value={formData.education} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
            <label className="form-label">Occupation / Job Title <span className="text-danger">*</span></label>
            <input type="text" name="occupation" value={formData.occupation} onChange={handleChange} className="form-control" required />
        </div>
         <div className="mb-3">
            <label className="form-label">Company / Organization</label>
            <input type="text" name="company" value={formData.company} onChange={handleChange} className="form-control" />
        </div>
        <div className="mb-3">
            <label className="form-label">Annual Income (Optional)</label>
            <select name="annualIncome" value={formData.annualIncome} onChange={handleChange} className="form-select">
                <option value="">Prefer not to say</option>
                <option>Less than ₹3 Lakh</option>
                <option>₹3 - ₹5 Lakh</option>
                <option>₹5 - ₹10 Lakh</option>
                <option>₹10 - ₹20 Lakh</option>
                <option>More than ₹20 Lakh</option>
            </select>
        </div>
    </div>
);

export default Section3ProfessionalInfo;